import { SET_MY_CARS_DATA } from './types';

export function setMyCarsData(data) {
	return {
		type: SET_MY_CARS_DATA,
		payload: data
	};
}
